<template>
  <div class="credit-card-component">
    <div class="credit-card-component__card">
      <svg width="544" height="352" viewBox="0 0 544 352" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="544" height="352" rx="16" fill="#4C91FF"/>
        <rect width="544" height="352" rx="16" fill="url(#paint0_linear)"/>
        <defs>
        <linearGradient id="paint0_linear" x1="-1.16126e-06" y1="14.5" x2="544" y2="252" gradientUnits="userSpaceOnUse">
        <stop stop-color="white" stop-opacity="0.43"/>
        <stop offset="1" stop-opacity="0.14"/>
        </linearGradient>
        </defs>
      </svg>
      <svg class="credit-card-component__card__logo" width="45" height="46" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M44.1524 18.8481C48.5375 33.3262 32.0501 50.5106 12.7162 44.8076C2.89646 41.911 0.340753 35.4917 0.907279 30.802C1.66286 24.5473 8.03328 22.567 10.6653 20.0969C14.506 16.4925 7.2077 8.30407 18.0067 1.72719C26.7124 -3.57477 39.7154 4.19851 44.1524 18.8481Z" fill="white"/>
      </svg>
      <label class="credit-card-component__card__cvv">
        <span v-html="$t('misc.creditCard.securityCodeLabel')"></span>
        <span class="credit-card-component__card__cvv__number">{{ this.cardCVV || '000' }}</span>
      </label>
      <label class="credit-card-component__card__number">
        {{ formattedCardNumber }}
      </label>
      <label class="credit-card-component__card__holder">
        {{ this.cardHolderName || 'Nome impresso no cartão' }}
      </label>
      <label class="credit-card-component__card__expiration">
        {{ this.cardExpirationMonth || $t('misc.creditCard.expiration.month') }}/{{ this.cardExpirationYear || $t('misc.creditCard.expiration.year') }}
      </label>
      <div class="credit-card-component__card__issuer">
        <component :is="getCardIssuerIconComponent(this.cardIssuer)" />
      </div>
    </div>
    <div class="credit-card-component__issuers">
      <div class="credit-card-component__issuers__icon"
        :class="{'credit-card-component__issuers__icon--selected': this.cardIssuer === 1}"
      >
        <visa-card-icon />
      </div>
      <div class="credit-card-component__issuers__icon"
        :class="{'credit-card-component__issuers__icon--selected': this.cardIssuer === 2}"
      >
        <master-card-icon />
      </div>
      <div class="credit-card-component__issuers__icon"
        :class="{'credit-card-component__issuers__icon--selected': this.cardIssuer === 3}"
      >
        <elo-card-icon />
      </div>
      <div class="credit-card-component__issuers__icon"
        :class="{'credit-card-component__issuers__icon--selected': this.cardIssuer === 4}"
      >
        <hiper-card-icon />
      </div>
      <div class="credit-card-component__issuers__icon"
        :class="{'credit-card-component__issuers__icon--selected': this.cardIssuer === 5}"
      >
        <amex-card-icon />
      </div>
    </div>
  </div>
</template>

<script>
const CardIssuerIconComponentMap = [
  'visa-card-icon', 'master-card-icon', 'elo-card-icon', 'hiper-card-icon', 'amex-card-icon'
]
export default {
  name: 'credit-card-component',
  props: {
    cardCVV: { type: String, required: true },
    cardNumber: { type: String, required: true },
    cardHolderName: { type: String, required: true },
    cardExpirationMonth: { type: String, required: true },
    cardExpirationYear: { type: String, required: true }
  },
  computed: {
    formattedCardNumber() {
      if (this.cardNumber) {
        let formatted = ''
        this.cardNumber.split('').forEach((it, i) => {
          if (i > 0 && i % 4 === 0) {
            formatted += ` ${it}`
          } else {
            formatted += it
          }
        })
        return formatted
      }
      return '0000 0000 0000 0000'
    },
    cardIssuer() {
      if (this.cardNumber && this.cardNumber.length >= 2) {
        const iin = Number(this.cardNumber.substring(0, 2))
        if (iin >= 40 && iin <= 49) {
          return 1
        } else if (iin >= 50 && iin <= 59) {
          return 2
        } else if (iin === 34 || iin === 37) {
          return 5
        } else if (iin === 38 || iin === 60) {
          return 4
        } else {
          if (this.cardNumber.length >= 6) {
            const iin6 = Number(this.cardNumber.substring(0, 6))
            if ([401178, 401179, 431274, 438935, 451416, 457393, 457631, 457632, 504175, 627780, 636297, 636368, 636369, 655000, 655001, 651652, 651653, 651654, 650485, 650486, 650487, 650488, 655002, 655003, 650489, 650490, 650491, 650492, 650493, 650494].includes(iin6) || [(iin6 >= 506699 && iin6 <= 506778), (iin6 >= 509000 && iin6 <= 509999), (iin6 >= 650000 && iin6 <= 659999)].some(it => it)) {
              return 3
            }
          }
        }
      }
      return 0
    }
  },
  methods: {
    getCardIssuerIconComponent(cardIssuerIndex) {
      if (cardIssuerIndex > 0) {
        return CardIssuerIconComponentMap[cardIssuerIndex - 1]
      }
      return null
    }
  }
}
</script>
<style lang="scss" scoped>
  .credit-card-component {
    display: flex;
    flex-direction: column;

    &__card {
      position: relative;
      &__logo {
        position: absolute;
        top: 40px;
        left: 40px;
      }
      &__cvv {
        position: absolute;
        top: 40px;
        left: 410px;

        display: flex;
        align-items: center;

        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 11.33px;
        line-height: 10px;
        text-align: right;
        color: #FFFFFF;

        &__number {
          margin-left: 0.5rem;
          font-family: Nunito;
          font-style: normal;
          font-weight: 900;
          font-size: 23.04px;
          line-height: 31px;
          color: #FFFFFF;
        }
      }
      &__number {
        position: absolute;
        top: 150px;
        left: 40px;

        font-family: Nunito;
        font-style: normal;
        font-weight: 900;
        font-size: 27.65px;
        line-height: 33px;
        color: #FFFFFF;
      }
      &__holder {
        position: absolute;
        top: 210px;
        left: 40px;

        font-family: Nunito;
        font-style: normal;
        font-weight: 900;
        font-size: 23.04px;
        line-height: 31px;
        color: #FFFFFF;
      }
      &__expiration {
        position: absolute;
        top: 250px;
        left: 40px;

        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 19.2px;
        line-height: 24px;
        color: #FFFFFF;
      }
      &__issuer {
        position: absolute;
        top: 260px;
        right: 35px;
        padding: 0 6px 0 6px;
        background-color: #fff;
        border-radius: 3px;
        svg {
          width: 50px;
          height: 34px;
        }
      }
    }

    &__issuers {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 80px;
      margin-top: 1rem;

      &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90px;
        height: 60px;
        box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        opacity: 0.3;
        &--selected {
          opacity: 1;
        }
      }
    }
  }
</style>
